import React from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 400,
  color: theme.palette.text.white,
}));
